const createGoogleSearchLink = (linkTerms) => {
  const linkTermsString = linkTerms.map((term) => encodeURI(term)).join('+');
  return `https://www.google.com/search?client=safari&rls=en&q=${linkTermsString}&ie=UTF-8&oe=UTF-8`;
};

export default createGoogleSearchLink;
